(function () {
  function init(rootDoc = document) {
    const roots = rootDoc.querySelectorAll('[data-lang-switch]');
    roots.forEach((root) => {
      if (root.dataset.langInit === '1') return;
      root.dataset.langInit = '1';

      const select = root.querySelector('[data-lang-native]');
      const btn = root.querySelector('[data-lang-btn]');
      const label = root.querySelector('[data-lang-label]');
      const menu = root.querySelector('[data-lang-menu]');
      if (!select || !btn || !label || !menu) return;

      // build menu
      menu.innerHTML = '';
      [...select.options].forEach((opt) => {
        const li = document.createElement('li');
        li.role = 'option';
        li.dataset.value = opt.value;
        li.textContent = opt.textContent.trim();
        li.setAttribute('aria-selected', opt.selected ? 'true' : 'false');
        menu.appendChild(li);
      });

      const sync = () => {
        const current = select.options[select.selectedIndex];
        label.textContent = current ? current.textContent.trim() : 'Language';
        [...menu.children].forEach(li => {
          li.setAttribute('aria-selected', li.dataset.value === select.value ? 'true' : 'false');
        });
      };

      const setOpen = (open) => {
        root.dataset.open = open ? 'true' : 'false';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      };

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // close other dropdowns
        document.querySelectorAll('[data-lang-switch]').forEach(other => {
          if (other !== root) other.dataset.open = 'false';
        });

        setOpen(root.dataset.open !== 'true');
      });

      menu.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const li = e.target.closest('li[data-value]');
        if (!li) return;

        select.value = li.dataset.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
        setOpen(false);
      });

      // outside click close (capture)
      document.addEventListener('click', (e) => {
        if (!root.contains(e.target)) setOpen(false);
      }, true);

      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));

  const mo = new MutationObserver(() => init());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
